import { axiosApi } from "shared/api/axios";
import { NomenclaturesResponse } from "../types";

export const getNomenclature = async (
    typeClient: number, 
    currentPage: number, 
    search_param?: string,
    order_by?: any,
    order_asc?: any,
): Promise<NomenclaturesResponse> => {
    try {
        const baseUrl = `${process.env.API_BACKEND}/v1/nomenclatures/nomenclature/?page=${currentPage}&size=10&order_asc=${order_asc}&order_by=${order_by}&storage=true`;
        const typeFilter = typeClient === 2 ? "&black_list_filter=true" : `&type_filter=${typeClient}`;
        const searchFilter = search_param ? `&search_param=${encodeURIComponent(search_param)}` : "";
        const url = `${baseUrl}${typeFilter}${searchFilter}`;

        const response = await axiosApi.get<NomenclaturesResponse>(url);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};